<template>

<v-card outlined>
  <v-card-title>Variabilität der Sprichwörter (Rang)</v-card-title>
  <v-card-subtitle>Jeder Punkt repräsentiert ein Sprichwort, der Name kann über Tootip angezeigt werden. 
    Die X-Achse zeigt den Rang des Sprichworts mit der engen Suchanfrage, die Y-Achse den Rang mit der
    weiten Suchanfrage. Die blaue Linie zeigt, wo die Punkte liegen würden, wenn sie für beide Suchanfragetypen
    genau den gleichen Rang hätten. Alle Sprichwörter unterhalb der Linie haben also einen höheren Rang 
    (und damit im Vergleich gesehen geringere Frequenz) mit der engen Suchanfrage als mit der weiten. Dies 
    deutet darauf hin, dass sie eher variabel sind (je weiter rechts unten in der Ecke desto extremer ist der 
    Unterschied).</v-card-subtitle>
  <v-card-text>
 
 <v-chart class="LineChart" 
   :option="lineOption"/> 
  </v-card-text>
</v-card>

</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { ScatterChart } from "echarts/charts";
import { LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  ScatterChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
]);

export default {
  name: "SpruchScatterplotRang",
  props: ['spruchdata'],
   components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },

   data() {
    return {
        
        //mydata: [["Klein, aber fein", 26.47, 1], ["Viel Lärm um Nichts", 94.75, 2], ["Weniger ist mehr", 52.04, 3], ["Der Schein trügt", 66.2, 2]],
        //mydata: [[26.47, 1, "Klein, aber fein"] , [ 94.75, 2, "Viel Lärm um Nichts"], [52.04, 3, "Weniger ist mehr"], [66.2, 2, "Der Schein trügt"]],
        //mydata: [[26.47, 1], [94.75, 2], [52.04, 3], [66.2, 2]],
        //mylabels: ["Klein, aber fein", "Viel Lärm um Nichts", "Weniger ist mehr", "Der Schein trügt"],
    };
  },
   methods: {
      
    },

    computed: {
      mydata() {
       var mydata = [];
        for (let index = 0; index <  this.spruchdata.length; ++index) {
            const element =  this.spruchdata[index];
            if (element.ratio <= 100) {
              mydata.push([ element.rang_eng, element.rang_weit, element.sprichw]);
            }
        }
        return mydata;
      },

      rang_eng_max() {
        var rang_eng_list = this.spruchdata.map(x=> x.rang_eng)
        return Math.max(...rang_eng_list);
      },

       rang_weit_max() {
        var rang_weit_list = this.spruchdata.map(x=> x.rang_weit)
        return Math.max(...rang_weit_list);
      },
      
        
      lineOption() {
        var option = {
tooltip: {
    trigger: 'item',
    axisPointer: {
      type: 'shadow'
    },
    formatter: function (param) {
      return param.data[2];
    }
  },


  xAxis: {
    splitLine: { show: false },
    nameLocation: 'middle',
    nameGap: 30,
    name: "Rang (eng)"
  },
  yAxis: {
    splitLine: { show: false },
    name: "Rang (weit)"
  },
  series: [
     {
      data: [[0, 0], [359, 359]],
      type: 'line',
      //areaStyle: {},
      color: "blue"
    },
    {
      data: this.mydata,
      type: 'scatter',
      color: "black",
      emphasis: {
        focus: 'self'
      },
      label: {
        show: false,
        formatter: function (param) {
          return param.data[2];
        },
        position: 'right',
        minMargin: 2
      }
    },
   

  ]
        }
    
    return option; 
    }
      },

};
</script>

<style scoped>
.LineChart {
  height: 1000px;
  width: 1000px;
}
</style>